import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  FETCH_SERVICES_REQUEST, fetchServicesSuccess, fetchServicesFailure,
  CREATE_SERVICE_REQUEST, createServiceSuccess, createServiceFailure,
  UPDATE_SERVICE_REQUEST, updateServiceSuccess, updateServiceFailure,
  DELETE_SERVICE_REQUEST, deleteServiceSuccess, deleteServiceFailure
} from '../actions/serviceActions';
import { getBaseUrl } from '../utils/getBaseUrl';

const API_BASE_URL = getBaseUrl();
const authToken = localStorage.getItem('authToken');
const getAuthToken = () => localStorage.getItem('authToken');

const createConfig = () => ({
  headers: { 'Authorization': `Bearer ${authToken}` }
});

function* fetchServices(action) {
  try {
    const token = getAuthToken();
    const { projectId, page = 1, limit = 2, search = '', group = '' } = action.payload || {};

    console.log("Fetching services data with payload: ", { projectId, page, limit, search, group });

    const baseUrl = getBaseUrl();

    const response = yield call(
      axios.get,
      `${baseUrl}/${projectId}/service`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params: { page, limit, search, group },
      }
    );

    // Assuming response structure includes `data` and `meta`
    yield put(fetchServicesSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || error.message || "An unknown error occurred";
    console.error("Error fetching services data: ", errorMessage);
    yield put(fetchServicesFailure(errorMessage));
  }
}

function* createService(action) {
  try {
    const response = yield call(axios.post, `${API_BASE_URL}/${action.payload.projectId}/service`, action.payload.data, createConfig());
    yield put(createServiceSuccess(response.data));
  } catch (error) {
    yield put(createServiceFailure(error.message));
  }
}

function* updateService(action) {
  try {
    const { id, data,projectId } = action.payload;
    const response = yield call(axios.put, `${API_BASE_URL}/${projectId}/service/${id}`, data, createConfig());
    yield put(updateServiceSuccess(response.data));
  } catch (error) {
    yield put(updateServiceFailure(error.message));
  }
}

function* deleteService(action) {
  try {
    const { id,projectId } = action.payload;
    yield call(axios.delete, `${API_BASE_URL}/${id}/service/${projectId}`, createConfig());
    yield put(deleteServiceSuccess(id));
  } catch (error) {
    yield put(deleteServiceFailure(error.message));
  }
}

export default function* serviceSaga() {
  yield takeLatest(FETCH_SERVICES_REQUEST, fetchServices);
  yield takeLatest(CREATE_SERVICE_REQUEST, createService);
  yield takeLatest(UPDATE_SERVICE_REQUEST, updateService);
  yield takeLatest(DELETE_SERVICE_REQUEST, deleteService);
}
